import { z } from 'zod'
import { ProductSubItemStatus } from '~/enums/product-sub-item-status'
import { TrueFalse } from '~/enums/true-false'

/**
 * 產品子類目 - 子網頁分類（新增）Schema
 */
export const createProductSubItemRequestSchema = z.object({
  /** 子網頁類型中文名稱 */
  psiNameZh: z.string().optional(),
  /** 子網頁類型英文名稱 */
  psiNameEn: z.string().optional(),
  /** 狀態 */
  status: z.literal(ProductSubItemStatus.ADD),
  /** 資料排序 */
  dataIndex: z.number()
})

/**
 * 產品子類目 - 新增 Request Schema
 */
export const createProductSubRequestSchema = z.object({
  /** 用途說明(中) */
  descriptionZh: z.string().optional(),
  /** 用途說明(英) */
  descriptionEn: z.string().optional(),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 子網頁分類 */
  items: z.array(createProductSubItemRequestSchema),
  /** 子類目名稱(英) */
  nameEn: z.string(),
  /** 子類目名稱(中) */
  nameZh: z.string(),
  /** 主類目 */
  pmID: z.number(),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')]).optional()
})

/**
 * 產品子類目 - 新增 Request
 */
export interface CreateProductSubRequest
  extends z.infer<typeof createProductSubRequestSchema> {}
